<tec-modal
	[isVisible]="isVisible"
	[title]="'LIFE_CHECK.HELP.TITLE' | translate"
	(closeEvent)="closeModal()">
	<ng-container body>
		<span>{{ 'GENERAL.ERROR.MODAL_NO_PERMISSION_CAMERA.DESCRIPTION1' | translate }}</span>
		<tec-tile icon="icon-info" [title]="'GENERAL.ERROR.MODAL_NO_PERMISSION_CAMERA.DESCRIPTION2' | translate">

			<ng-container body>
				<ul>
					<li>{{ 'GENERAL.ERROR.MODAL_NO_PERMISSION_CAMERA.DESCRIPTION3' | translate }}</li>
					<li>{{ (hasActiveRecording ? 'GENERAL.ERROR.MODAL_NO_PERMISSION_CAMERA.DESCRIPTION4_WITH_RECORDING' : 'GENERAL.ERROR.MODAL_NO_PERMISSION_CAMERA.DESCRIPTION4') | translate }}</li>
				</ul>
				<tec-qr [url]="url" [copyLabel]="'GENERAL.BUTTON.COPY_LINK' | translate" />
			</ng-container>
		</tec-tile>
	</ng-container>
</tec-modal>